export { PeoplePage } from './pages/PeoplePage';
export type { PeoplePageProps } from './pages/PeoplePage';
export type { PeopleAccess, PeopleWorker } from './operations/model';
export type { PeopleOperationsPort, PeopleRoutePort } from './operations/port';
export { EmployeeProfilePage } from './pages/EmployeeProfilePage';
export { workerStatusPresentation } from './profile/workerStatusPresentation';
export { buildPersonNameUpdateInput, personNameDraftFromProfile, validatePersonNameDraft } from './profile/PersonNameChangeDialog';
export type { EmployeeProfilePageProps, EmployeeProfileViewer } from './pages/EmployeeProfilePage';
export type {
  CareerProfilePort,
  ContactChangePort,
  FamilyProfilePort,
  PeopleProfilePort,
  PersonNamePort,
  PrivateProfilePort,
  ProfileOverviewPort,
  ProfilePhotoPort,
} from './profile/port';
export { fixtureEmployeeDirectory } from './directory/fixtures';
export type {
  EmployeeDirectoryMember,
  EmployeeDirectoryOrganization,
  EmployeeDirectoryProfile,
  EmployeeDirectorySnapshot,
} from './directory/model';
export type { EmployeeDirectoryPort, EmployeeDirectoryRoutePort, EmployeeDirectoryRouteState, EmployeeDirectoryView } from './directory/port';
export { buildEmployeeDirectoryIndex, employeeDirectoryMemberships, matchesDirectoryQuery, normalizeDirectoryQuery, unassignedOrganization } from './directory/directoryIndex';

export const loadDirectoryPage = () => import('./pages/DirectoryPage');
export { parsePeopleSavedViews } from './operations/peopleWorkspace';
export type { PeopleViewPreferencesPort } from './operations/peopleWorkspace';
